'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryQuotationEditor = require('./components/PrimaryQuotationEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryQuotationEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/primary-quotation-editor/index.js
// module id = 1037
// module chunks = 4